import Link from '@amzn/meridian/link';
import Thumbnail from '@amzn/meridian/thumbnail';
import { ThumbnailSize } from '@amzn/meridian/thumbnail/thumbnail';
import Tooltip from '@amzn/meridian/tooltip';
import React from 'react';
import { useNavigate } from 'react-router';

interface BadgeProps {
  username: string;
  givenName?: string;
  tooltip?: boolean;
  link?: string;
  thumbNail?: boolean;
  thumbnailSize?: ThumbnailSize;
}

export const generateBadgeUrl = (uid: string) =>
  `https://cdn.prod.badgephotos.side.amazon.dev/?uid=${uid}`;

const UserBadge: React.FC<BadgeProps> = ({
  username,
  givenName,
  tooltip,
  link,
  thumbNail,
  thumbnailSize,
}: BadgeProps): React.ReactElement => {
  const navigate = useNavigate();
  const fallbackURLSrc = `https://pulse.amazon.com/user/${username}/badge/100x100`;
  let component = (
    <img
      alt={`${username} badge`}
      src={generateBadgeUrl(username)}
      onError={(e): void => {
        e.currentTarget.src = fallbackURLSrc;
        e.currentTarget.onerror = null;
      }}
      style={{ maxHeight: '100%', maxWidth: '100%' }}
    />
  );
  if (thumbNail) {
    component = (
      <Thumbnail source={generateBadgeUrl(username)} size={thumbnailSize} />
    );
  }
  if (tooltip) {
    if (link) {
      component = (
        <Link
          data-csa-c-type='link'
          data-csa-c-slot-id='dashboard-user-badge-slot'
          data-csa-c-content-id={`dashboard-user-badge-for-${username}`}
          href={link}
          onClick={navigate}
          type='secondary'
        >
          {component}
        </Link>
      );
    }

    return (
      <Tooltip title={`${givenName ?? ''} ${username}`} position='bottom'>
        {component}
      </Tooltip>
    );
  }

  return component;
};

export default UserBadge;
